import { formatPrice } from "../../helpers";

const RecommendedCartProduct = (data) => {
  const firstAvailableVariant = data.product.variants.find(
    (variant) => variant.available
  );
  return `
    <div
      class="line-item line-item--no-margin"
      data-controller="line-item"
      data-product="${data.product.id}"
      data-handle="${data.product.handle}"
      data-line-item-variant-value="${firstAvailableVariant.id}"
    >
      <input type="hidden" value="1" name="quantity" data-line-item-target="quantity" />
      
      <a href="/products/${data.product.handle}${
    data.product.variants[0] ? `?variant=${data.product.variants[0].id}` : ""
  }">
        <img
          class="line-item__image"
          src="${data.product.media[0].src}&width=140&height=140&crop=center"
          alt="${data.product.title}"
          height="140"
          width="140"
          loading="lazy"
        />
      </a>

      <div>
        <h3 class="line-item__title">
          <a href="/products/${data.product.handle}${
    data.product.variants[0] ? `?variant=${data.product.variants[0].id}` : ""
  }">
            ${data.product.title}
          </a>  
        </h3>
        ${
          firstAvailableVariant.title !== "Default Title"
            ? `<p class="line-item__variant">${firstAvailableVariant.title}</p>`
            : ""
        }
        <p class="line-item__price">
          ${formatPrice(firstAvailableVariant.price)}
        </p>

        <a
          href="#"
          class="line-item__remove"
          data-action="quickcart#addRecommendedProduct"
          data-quickcart-variant-param="${firstAvailableVariant.id}"
          data-quickcart-sku-param="${data.variants_meta[0].cc_sku}"
        >
          Add to Bag
        </a>
      </div>
    </div>
  `;
};

export default RecommendedCartProduct;
